/**
 * デバイス操作の定義。
 * 追加時はこの配列に { id, label, icon, renderModal } を追加する。
 */
import React from "react";
import {
  VideoCameraOutlined,
  MessageOutlined,
  MailOutlined,
} from "@ant-design/icons";
import type { Device } from "../web_parts/types";
import InfoSend_Agora from "../InfoSend_Agora";
import InfoSend_UserWebNotice from "../InfoSend_UserWebNotice";
import BBS from "../BBS";

export type OperationId = "agora" | "bbs" | "userweb_notice";

export interface DeviceOperationItem {
  id: OperationId;
  label: string;
  icon: React.ReactNode;
  /** true のとき DeviceOperations 側で Modal でラップする（BBS などモーダルを持たないコンポーネント用） */
  wrapInModal?: boolean;
  renderModal: (device: Device, onClose: () => void) => React.ReactNode;
}

/** デバイス操作一覧（追加・並び替えはここで行う） */
export const DEVICE_OPERATIONS: DeviceOperationItem[] = [
  {
    id: "agora",
    label: "テレビ会議の接続",
    icon: <VideoCameraOutlined />,
    wrapInModal: false,
    renderModal: (device, onClose) => (
      <InfoSend_Agora singleDevice={device} onClose={onClose} />
    ),
  },
  {
    id: "bbs",
    label: "掲示板の表示",
    icon: <MessageOutlined />,
    wrapInModal: true,
    renderModal: (device, onClose) => <BBS device={device} onClose={onClose} />,
  },
  {
    id: "userweb_notice",
    label: "ユーザーWebへのお知らせ",
    icon: <MailOutlined />,
    wrapInModal: false,
    renderModal: (device, onClose) => (
      <InfoSend_UserWebNotice target="device" device={device} onClose={onClose} />
    ),
  },
];
